<template>
  <div class="reason-selector-preview">
    <div v-for="(reason, index) in displayReasons" :key="index" class="reason-item">
      <!-- 原因文本 -->
      <div class="reason-text">{{ reason.label }}</div>

      <!-- 补充说明（如果有） -->
      <div v-if="reason.remark" class="reason-remark">
        {{ reason.remark }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReasonSelectorPreviewText',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    displayReasons() {
      if (!this.value || !Array.isArray(this.value)) return []

      return this.value.map(reason => {
        // 从 options 中查找对应的 label
        const option = this.options.find(opt => opt.value === reason.key)

        return {
          key: reason.key,
          label: option ? option.label : reason.key,
          remark: reason.remark || '',
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.reason-selector-preview {
  .reason-item {
    margin-top: 8px;
    margin-bottom: 32px;

    &:first-child {
      margin-top: 48px;
    }

    &:last-child {
      margin-bottom: 0;
    }

    .reason-text {
      font-family: DiDiSans-Pro-Regular;
      font-size: 28px;
      color: #282b33;
      line-height: 40px;
      margin-bottom: 16px;
    }

    .reason-remark {
      font-family: DiDiSans-Pro-Regular;
      font-size: 28px;
      color: #595c66;
      line-height: 40px;
      padding: 16px;
      background: #f5f5f7;
      border-radius: 40px;
      word-break: break-word;
    }
  }
}
</style>
